import { render, staticRenderFns } from "./writeXaOut.vue?vue&type=template&id=6f78dd78&scoped=true"
import script from "./writeXaOut.vue?vue&type=script&lang=js"
export * from "./writeXaOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78dd78",
  null
  
)

export default component.exports